var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlaggedForReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 251,
    viewBox: "0 0 255 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.699951 0.599609H254.5V250.9H0.699951V0.599609Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2001 205.399C97.4726 205.399 105.8 197.072 105.8 186.799C105.8 176.527 97.4726 168.199 87.2001 168.199C76.9276 168.199 68.6001 176.527 68.6001 186.799C68.6001 197.072 76.9276 205.399 87.2001 205.399Z",
    fill: "#CFD4DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2001 205.399C92.2001 205.399 96.7001 203.399 100.1 200.199C98.7001 194.299 93.4001 189.799 87.1001 189.799C80.8001 189.799 75.6001 194.099 74.1001 199.999C77.5001 203.299 82.1001 205.399 87.2001 205.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6001 180.398C80.6001 183.998 83.5001 186.898 87.1001 186.898C90.7001 186.898 93.6001 183.998 93.6001 180.398C93.6001 176.798 90.7001 173.898 87.1001 173.898C83.5001 173.898 80.6001 176.798 80.6001 180.398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2001 205.399C97.4726 205.399 105.8 197.072 105.8 186.799C105.8 176.527 97.4726 168.199 87.2001 168.199C76.9276 168.199 68.6001 176.527 68.6001 186.799C68.6001 197.072 76.9276 205.399 87.2001 205.399Z",
    stroke: "#CFD4DB",
    strokeWidth: 3.9935,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1 240.301L50 240.401C44.5 240.401 40.1 236.001 40.1 230.501L40 33.3008C40 27.8008 44.4 23.4008 49.9 23.4008L209 23.3008C214.5 23.3008 218.9 27.7008 218.9 33.2008L219 230.301C219 235.801 214.5 240.301 209.1 240.301Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.8 38.5V225.2H120.2H55.2001L55.1001 38.6L203.8 38.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.3 47.6C190.3 38.9 183.3 31.9 174.6 31.9H160.8C152.1 31.9 145.1 24.9 145.1 16.2C145.1 7.5 138.1 0.5 129.4 0.5C120.7 0.5 113.7 7.5 113.7 16.2C113.7 24.9 106.7 31.9 98 31.9H84.2C75.5 31.9 68.5 38.9 68.5 47.6V49.5H113.6H145H190.1L190.3 47.6ZM129.5 27.1C123 27.1 117.7 21.8 117.7 15.3C117.7 12.2 118.9 9.2 121.1 7C123.3 4.8 126.3 3.5 129.4 3.5C132.5 3.5 135.5 4.7 137.7 6.9C139.9 9.1 141.2 12.1 141.2 15.2C141.2 21.8 136 27.1 129.5 27.1Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5 3.5C129.4 3.5 129.4 3.5 129.5 3.5C126.3 3.5 123.4 4.7 121.2 7C119 9.2 117.7 12.2 117.8 15.3C117.8 21.8 123.1 27.1 129.6 27.1C136.1 27.1 141.4 21.8 141.4 15.3C141.4 12.2 140.2 9.2 137.9 7C135.6 4.7 132.6 3.5 129.5 3.5ZM129.5 23.1C125.2 23.1 121.7 19.6 121.7 15.3C121.7 13.2 122.5 11.3 124 9.8C125.5 8.3 127.4 7.5 129.5 7.5C131.6 7.5 133.5 8.3 135 9.8C136.5 11.3 137.3 13.2 137.3 15.3C137.2 19.6 133.8 23.1 129.5 23.1Z",
    fill: "#FFD740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8 49.5992H145.2H190.3V47.6992C190.3 46.6992 190.2 45.6992 190 44.6992H69C68.8 45.6992 68.7 46.6992 68.7 47.6992V49.5992H113.8Z",
    fill: "#FFD740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.8 90.1004L189.9 85.3004L182.6 74.9004L171.8 90.1004Z",
    fill: "#FEEFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 88.2L176.1 84L171.8 90.1L179 88.2Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.4 33.0008L249.6 43.4008L251.9 41.8008C254.7 39.9008 255.3 36.1008 253.4 33.3008L253.1 32.9008C251.2 30.1008 247.4 29.5008 244.6 31.4008L242.4 33.0008Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.6 74.9L189.9 85.3L246.1 45.9L238.9 35.5L182.6 74.9Z",
    fill: "#FDC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.2 80.0992L189.9 85.2992L246.1 45.8992L242.5 40.6992L186.2 80.0992Z",
    fill: "#FFD740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.6 74.9L186.2 80.1L242.5 40.7L238.9 35.5L182.6 74.9Z",
    fill: "#FCB123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.753 36.8821L243.993 47.3164L251.552 42.0715L244.311 31.6372L236.753 36.8821Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2001 102.1C97.4726 102.1 105.8 93.7729 105.8 83.5004C105.8 73.2279 97.4726 64.9004 87.2001 64.9004C76.9276 64.9004 68.6001 73.2279 68.6001 83.5004C68.6001 93.7729 76.9276 102.1 87.2001 102.1Z",
    fill: "#2C80FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2001 102.1C92.2001 102.1 96.7001 100.1 100.1 96.9C98.7001 91 93.4001 86.5 87.1001 86.5C80.8001 86.5 75.6001 90.8 74.1001 96.7C77.5001 100 82.1001 102.1 87.2001 102.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6001 77.0996C80.6001 80.6996 83.5001 83.5996 87.1001 83.5996C90.7001 83.5996 93.6001 80.6996 93.6001 77.0996C93.6001 73.4996 90.7001 70.5996 87.1001 70.5996C83.5001 70.5996 80.6001 73.4996 80.6001 77.0996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2001 104.1C75.8001 104.1 66.6001 94.9004 66.6001 83.5004C66.6001 72.1004 75.8001 62.9004 87.2001 62.9004C98.6001 62.9004 107.8 72.1004 107.8 83.5004C107.8 94.9004 98.6001 104.1 87.2001 104.1ZM87.2001 66.9004C78.0001 66.9004 70.6001 74.3004 70.6001 83.5004C70.6001 92.7004 78.0001 100.1 87.2001 100.1C96.4001 100.1 103.8 92.7004 103.8 83.5004C103.8 74.3004 96.4001 66.9004 87.2001 66.9004Z",
    fill: "#2C80FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2001 153.7C97.4726 153.7 105.8 145.372 105.8 135.1C105.8 124.828 97.4726 116.5 87.2001 116.5C76.9276 116.5 68.6001 124.828 68.6001 135.1C68.6001 145.372 76.9276 153.7 87.2001 153.7Z",
    fill: "#CFD4DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2001 153.7C92.2001 153.7 96.7001 151.7 100.1 148.5C98.7001 142.6 93.4001 138.1 87.1001 138.1C80.8001 138.1 75.6001 142.4 74.1001 148.3C77.5001 151.6 82.1001 153.7 87.2001 153.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6001 128.699C80.6001 132.299 83.5001 135.199 87.1001 135.199C90.7001 135.199 93.6001 132.299 93.6001 128.699C93.6001 125.099 90.7001 122.199 87.1001 122.199C83.5001 122.199 80.6001 125.099 80.6001 128.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2001 153.7C97.4726 153.7 105.8 145.372 105.8 135.1C105.8 124.828 97.4726 116.5 87.2001 116.5C76.9276 116.5 68.6001 124.828 68.6001 135.1C68.6001 145.372 76.9276 153.7 87.2001 153.7Z",
    stroke: "#CFD4DB",
    strokeWidth: 3.9935,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2001 203.399C97.4726 203.399 105.8 195.072 105.8 184.799C105.8 174.527 97.4726 166.199 87.2001 166.199C76.9276 166.199 68.6001 174.527 68.6001 184.799C68.6001 195.072 76.9276 203.399 87.2001 203.399Z",
    fill: "#CFD4DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2001 203.399C92.2001 203.399 96.7001 201.399 100.1 198.199C98.7001 192.299 93.4001 187.799 87.1001 187.799C80.8001 187.799 75.6001 192.099 74.1001 197.999C77.5001 201.299 82.1001 203.399 87.2001 203.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6001 178.398C80.6001 181.998 83.5001 184.898 87.1001 184.898C90.7001 184.898 93.6001 181.998 93.6001 178.398C93.6001 174.798 90.7001 171.898 87.1001 171.898C83.5001 171.898 80.6001 174.798 80.6001 178.398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2001 203.399C97.4726 203.399 105.8 195.072 105.8 184.799C105.8 174.527 97.4726 166.199 87.2001 166.199C76.9276 166.199 68.6001 174.527 68.6001 184.799C68.6001 195.072 76.9276 203.399 87.2001 203.399Z",
    stroke: "#CFD4DB",
    strokeWidth: 3.9935,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.2 96.0996H108V100.1H186.2V96.0996Z",
    fill: "#CFD4DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.2 147.699H108V151.699H186.2V147.699Z",
    fill: "#CFD4DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.2 199.4H108V203.4H186.2V199.4Z",
    fill: "#CFD4DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3 92.0995C124.7 92.0995 124.2 91.9995 123.6 91.7995C121 90.6995 120.6 87.3995 120.4 84.5995C120.3 83.3995 120 80.6996 119.4 80.3996C119.4 80.3996 118.2 79.9995 114.7 83.4995L111.9 80.6995C114.3 78.3995 117.8 75.3995 120.9 76.7995C123.7 77.8995 124 81.2995 124.3 84.2995C124.4 85.4995 124.7 87.8995 125.1 88.2995C126 88.6995 129.2 85.5995 130.7 84.0995C134.3 80.5995 138.4 76.6995 142.7 77.9995C145.7 78.8995 146.9 81.7995 147.9 84.1995C148.8 86.2995 149.4 87.5995 150.3 87.7995C151.6 88.0995 153.4 86.3996 155.1 84.8996C157.6 82.5996 160.4 80.0995 164 80.7995C166.3 81.2995 168.3 83.0995 169.8 86.0995L166.2 87.8996C165.3 86.0996 164.2 84.9995 163.2 84.6995C161.6 84.3995 159.8 85.9995 157.9 87.7995C155.6 89.8995 152.9 92.3995 149.6 91.6995C146.4 91.0995 145.2 88.0995 144.2 85.6995C143.3 83.5995 142.7 82.1995 141.6 81.7995C139.5 81.1995 136.2 84.3995 133.5 86.9995C130.7 89.5996 128 92.0995 125.3 92.0995Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5001 40.6008C90.8256 40.6008 91.9001 39.5263 91.9001 38.2008C91.9001 36.8753 90.8256 35.8008 89.5001 35.8008C88.1746 35.8008 87.1001 36.8753 87.1001 38.2008C87.1001 39.5263 88.1746 40.6008 89.5001 40.6008Z",
    fill: "#FFD740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.4 40.6008C170.725 40.6008 171.8 39.5263 171.8 38.2008C171.8 36.8753 170.725 35.8008 169.4 35.8008C168.075 35.8008 167 36.8753 167 38.2008C167 39.5263 168.075 40.6008 169.4 40.6008Z",
    fill: "#FFD740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6001 158.8L61.8 141.4L52.3 149.7L68.6001 158.8Z",
    fill: "#FEEFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2 155.2L68.6 158.8L65.8999 151.9L62.2 155.2Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99996 95.0001L13.5 86.7001L11.7 84.6001C9.49996 82.1001 5.69996 81.8001 3.09996 84.0001L2.69996 84.3001C0.199962 86.5001 -0.100038 90.3001 2.09996 92.9001L3.99996 95.0001Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2999 149.7L61.7999 141.4L16.3999 89.9004L6.8999 98.3004L52.2999 149.7Z",
    fill: "#FDC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1 145.6L61.9 141.4L16.4 89.9004L11.7 94.1004L57.1 145.6Z",
    fill: "#FFD740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2999 149.7L57.0999 145.6L11.5999 94.0996L6.8999 98.2996L52.2999 149.7Z",
    fill: "#FCB123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5433 100.152L18.1013 91.7891L12.0431 84.8651L2.4851 93.2281L8.5433 100.152Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4 219.4L173.6 230.3L177.1 218.1L158.4 219.4Z",
    fill: "#FEEFD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8 218.9L158.4 219.4L164.5 223.7L165.8 218.9Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.3 237.699L243.8 249.899L246.5 250.699C249.7 251.599 253.1 249.699 254 246.499L254.1 245.999C255 242.799 253.1 239.399 249.9 238.499L247.3 237.699Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.1 218.1L173.6 230.3L239.7 248.7L243.2 236.5L177.1 218.1Z",
    fill: "#FDC150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3 224.199L173.6 230.299L239.7 248.699L241.5 242.599L175.3 224.199Z",
    fill: "#FFD740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.1 218.1L175.3 224.2L241.5 242.6L243.2 236.5L177.1 218.1Z",
    fill: "#FCB123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.786 235.856L237.321 248.074L246.173 250.584L249.637 238.365L240.786 235.856Z",
    fill: "#0065FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 33.462,
    y1: 227.902,
    x2: 225.526,
    y2: 35.8373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0065FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66A3FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.699951 0.599609H254.5V250.9H0.699951V0.599609Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaggedForReview);
export default __webpack_public_path__ + "static/media/flagged-for-review.67f6c0507c0020ad0c41396ad83aa43a.svg";
export { ForwardRef as ReactComponent };